import script from "./ChatTicketsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTicketsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatTicketsModal.vue?vue&type=style&index=0&id=d0f0dc88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f0dc88"]])

export default __exports__